

query loginImpersonate($token: String) {
    loginImpersonate(token: $token)
}
